// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var GraphqlTag = require("graphql-tag").default;
var ApolloHooksQuery = require("./ApolloHooksQuery.bs.js");
var ApolloHooksMutation = require("./ApolloHooksMutation.bs.js");
var ApolloHooksSubscription = require("./ApolloHooksSubscription.bs.js");

function toQueryObj(result) {
  return {
          query: Curry._1(GraphqlTag, result.query),
          variables: result.variables
        };
}

var Mutation;

var Query;

var Provider;

var Subscription;

var useQuery = ApolloHooksQuery.useQuery;

var useMutation = ApolloHooksMutation.useMutation;

var useSubscription = ApolloHooksSubscription.useSubscription;

exports.Mutation = Mutation;
exports.Query = Query;
exports.Provider = Provider;
exports.Subscription = Subscription;
exports.useQuery = useQuery;
exports.useMutation = useMutation;
exports.useSubscription = useSubscription;
exports.toQueryObj = toQueryObj;
/* graphql-tag Not a pure module */
